import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Fetch } from "../../../shared/Fetch";
import { JVInput } from "../../../shared/JVInput";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { ITenderServiceDepartment, } from "./TenderServiceDepartmentMast";
import { InputTextarea } from "primereact/inputtextarea";

interface IProps {
    singleData: ITenderServiceDepartment;
    open: boolean;
    hideDialog: () => void;
    toast: any;
    reload: boolean;
    setReload: (reload: boolean) => void;
}

const schema = yup.object({
    department_Name: yup.string().required("Department Name is required"),
});

const Form = (props: IProps) => {

    const [loading, setLoading] = useState(false);
    const [description, setDescription] = useState("");

    const { control, handleSubmit, reset, formState: { errors, isDirty },
    } = useForm<ITenderServiceDepartment>({
        resolver: yupResolver(schema),
        defaultValues: { id: null, department_Name: "", description: "", status: true, },
    });

    useEffect(() => {

        if (props.open) {
            reset({
                id: props.singleData?.id,
                department_Name: props.singleData?.department_Name || "",
                description: props.singleData?.description || "",
                status: props.singleData?.status ?? true,
            });

            setDescription(props.singleData?.description || "");
        }

    }, [props.open, props.singleData]);

    const onSubmit = async (data: ITenderServiceDepartment) => {

        try {

            setLoading(true);
            let body: any = {
                id: data.id,
                department_Name: data.department_Name,
                description: description,
                status: data.status,
            };

            const endpoint = data.id ? `Tender_Service_Department/${data.id}` : "Tender_Service_Department";
            const method = data.id ? "PUT" : "POST";
            if (method === "POST") delete body.id;
            const response = await Fetch(endpoint, method, body, null, props.toast);

            if (response?.ok) {
                props.toast.current.show({
                    severity: "success", summary: "Success",
                    detail: data.id ? "Updated Successfully" : "Saved Successfully",
                });

                props.setReload(!props.reload);
                onHide();
            }

        } finally {
            setLoading(false);
        }
    };

    const onHide = () => {
        reset();
        setDescription("");
        props.hideDialog();
    };

    return (
        <Dialog visible={props.open} header={
            props.singleData?.id ? "Update Tender Service Department" : "Add Tender Service Department"
        }
            style={{ width: "40rem" }} onHide={onHide}
        >
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid"  >

                <JVInput required column={2} label="Department Name" control={control} name="department_Name" error={errors.department_Name?.message} />
                <div className="field col-12">
                    <label>Description</label>
                    <InputTextarea rows={4} value={description} onChange={(e) => setDescription(e.target.value)} />
                </div>

                <div className="col-12 flex justify-content-end gap-2">
                    <Button label={props.singleData?.id ? "UPDATE" : "SAVE"} loading={loading} type="submit" />
                    <Button label="CLOSE" type="button" className="p-button-outlined" onClick={onHide} />
                </div>
            </form>
        </Dialog>
    );
};

export default Form;